'use client'

import Image from 'next/image'
import { toAuthor } from '../jbda/author'
import { useAuthorDialog } from '../jbda/jbda/jbda-author'

export default function PostAuthor({ post, className = '' }: { post: any, className?: string }) {

  const { openAuthorDialog } = useAuthorDialog()

  if (!post.author) return null
  
  return (
    <div id='AUTHOR' className={'flex w-fit items-center cursor-help flex-nowrap ' + className} onClick={(e) => {
      e.preventDefault()
      e.stopPropagation()
      openAuthorDialog(toAuthor(post.author))
    }}>
      <div className={'mr-2 h-6 w-6 shrink-0'}>
        {post.author?.photo ? (
          <Image id='AUTHOR_IMAGE' src={post.author?.photo.url} alt={post.author?.name}
            className={'overflow-hidden rounded-full'}
            width={0}
            height={0}
            sizes='100vw'
            priority={true}
            style={{
              height: 24,
              width: 24
            }} />
        ) : (<></>
        )}
      </div>
      <div id='AUTHOR_NAME' className='whitespace-nowrap'>{post.author.name}</div>
    </div>

  )
}
